import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Namespace } from '../../../../../../translation/namespace';
import { SkipLink, SkipLinkTarget } from '../../../../../../_lib/components/SkipLink';

/**
 * Returning a skip links to the top & the bottom of the list
 * if there are more than 2 selected results.
 */
function SkipLinkTo({ target }) {
  const { t } = useTranslation(Namespace.FormsComboBoxMultiSelect);

  return (
    <SkipLink
      modifier={target === 'top' ? 'bottom' : null}
      id={`forms-combobox-multiselect-list-${target}`}
      focusTarget
    >
      {t(`resultlist.skipLink.${target}`)}
    </SkipLink>
  );
}
SkipLinkTo.propTypes = {
  target: PropTypes.oneOf(['top', 'bottom']).isRequired,
};

/**
 * Returns a <span> that is a placeholder for the end of the selection list
 * to make sure, we can focus this via skiplink an receive visual focus
 */
function PositionInSelectionInformation({ position }) {
  const { t } = useTranslation(Namespace.FormsComboBoxMultiSelect);

  return (
    <SkipLinkTarget
      targetName={t(`resultlist.skipLinkTarget.${position}`)}
      id={`forms-combobox-multiselect-list-${position}`}
    />
  );
}
PositionInSelectionInformation.propTypes = {
  position: PropTypes.oneOf(['top', 'bottom']).isRequired,
};

export { SkipLinkTo, PositionInSelectionInformation };
